import { render, staticRenderFns } from "./EmergencySign.vue?vue&type=template&id=58665114&scoped=true&"
import script from "./EmergencySign.vue?vue&type=script&lang=js&"
export * from "./EmergencySign.vue?vue&type=script&lang=js&"
import style0 from "./EmergencySign.vue?vue&type=style&index=0&id=58665114&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58665114",
  null
  
)

export default component.exports